module.exports = __webpack_public_path__ + "img/17877_S.a109f1c6.png";